import { Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { StepsButton } from './BtnSave';
import init from './init.json';
import { FormObserve } from './Step2';
import { useDpiaContext } from '../dpia.context';
import { useEffect } from 'react';

export default function Step3(props) {
    const { t } = useTranslation(['translation', 'dpia']);
    const { setStep3, setStepNo } = useDpiaContext();

    const onNextStep = () => {
        props.form
            .validateFields()
            .then(() => {
                setStep3(true);
            })
            .catch(() => {
                setStep3(false);
            });
        props.nextStep();
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    const onValuesChange = (info, value) => {
        const checkValue = (item) =>
            item?.topicName === '' ||
            item?.topicName === null ||
            item?.topicDescription === '' ||
            item?.topicDescription === null;

        const hasConsultation = value?.consultation?.some(checkValue);

        if (hasConsultation) {
            setStep3(false);
        } else {
            setStep3(true);
        }
    };
    useEffect(() => {
        setStepNo(3)
    }, []); 
    return (
        <div hidden={!props?.isActive}>
            <div className="flex">
                <div>
                    <h1 className="text-2xl font-semibold text-purple">
                        {t('step 3')}: {t('Consultation')}
                    </h1>
                    <p className="text-sm text-gray-PHX m-0">
                        {t('DPIA step 2 description')}
                    </p>
                </div>
            </div>
            <Divider />
            <div className="text-xl font-semibold">
                {t('DPIA step 2 description list')}
            </div>
            <ul className="pt-2">
                <li>เจ้าของข้อมูลส่วนบุคคล (Data subject)</li>
                <li>ผู้ประมวลผลข้อมูลส่วนบุคคล (Data processor)</li>
                <li>
                    ผู้เกี่ยวข้องภายในองค์กร (Internal stakeholders)
                    รวมถึงเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (DPO)
                </li>
                <li>
                    ผู้เชี่ยวชาญทางกฎหมายและผู้เชี่ยวชาญด้านที่เกี่ยวข้องจากภายนอก
                    (Independent experts)
                </li>
                <li>
                    สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (Data Protection
                    Agency)
                </li>
                <li>อื่นๆ (โปรดระบุ)</li>
            </ul>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                initialValues={init.consultation}
                layout="vertical"
                name="consultation"
                form={props?.form}
            >
                <FormObserve name="consultation" form={props?.form} />
            </Form>
            <Divider />
            <StepsButton previous={onPreviousStep} next={onNextStep} />
        </div>
    );
}
